export class TextLayers {
    static circleWithText(
        id,
        circleRadius,
        backgroundColor,
        textSize,
        textColor
    ) {
        let layers = [];

        layers.push({
            id: `${id}-circle`,
            type: 'circle',
            layout: {},
            paint: {
                'circle-radius': circleRadius,
                'circle-color': backgroundColor,
                'circle-stroke-width': 1,
                'circle-stroke-color': backgroundColor,
            },
        });

        layers.push({
            id: `${id}-text`,
            type: 'symbol',
            layout: {
                'text-field': ['get', 'checkpointName'],
                'text-anchor': 'center',
                'text-offset': [0, 0],
                'text-allow-overlap': true,
                'text-size': textSize,
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
            },
            paint: {
                'text-color': textColor,
                'text-halo-color': backgroundColor,
                'text-halo-width': textSize / 2,
            },
        });

        return layers;
    }
}
